import {
  createActions, asyncInitialState, asyncSelectors, dateComparator
} from '../../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  reset: () => null,
  setEntityView: (defaultView, defaultWarehouse) => ({ defaultView, defaultWarehouse }),
  asyncs: {
  }
}, 'IEPurchaseOrders');

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    toolPanel: false,
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
    rowModelType: 'serverSide',
    cacheBlockSize: 10,
    maxBlocksInCache: 5,
  },
  Columns: [
    { headerName: 'Warehouse', field: 'Warehouse', minWidth: 100, allowSorting: true, fixed: true, },
    {
      headerName: 'Purchase order',
      field: 'PurchaseOrder',
      minWidth: 120,
      suppressSorting: false,
      fixed: true,
      hyperlinkParamGetter: (row) => {
        if (row.data && row.data?.PurchaseOrder) {
          return {
            PurchaseOrder: row.data?.PurchaseOrder,
            FieldValue: row.data?.PurchaseOrder,
          };
        } else return null;
      },
      cellRenderer: 'hyperLinkRenderer',
      cellRendererParams: {
        link: '/purchase-order-enquiry'
      }
    },
    { headerName: 'Line', field: 'LineNo', minWidth: 50, suppressSorting: true },
    {
      headerName: 'Supplier',
      field: 'Supplier',
      hyperlinkParamGetter: (row) => {
        if (row.data && row.data?.Supplier) {
          return {
            Supplier: row.data?.Supplier,
            FieldValue: row.data?.Supplier,
          };
        } else return null;
      },
      cellRenderer: 'hyperLinkRenderer',
      cellRendererParams: {
        link: '/supplier-enquiry'
      },
      minWidth: 80,
      suppressSorting: true
    },
    { headerName: 'Supplier product', field: 'SupplierProduct', minWidth: 130, suppressSorting: true },
    { headerName: 'Buying unit', field: 'BuyingUnit', minWidth: 100, suppressSorting: true },
    { headerName: 'Status', field: 'Status', minWidth: 120, suppressSorting: true },
    { headerName: 'Created', field: 'Created', comparator: dateComparator, minWidth: 100, suppressSorting: true },
    { headerName: 'Ship', field: 'ShipDate', comparator: dateComparator, minWidth: 150, suppressSorting: true },
    { headerName: 'Due', field: 'DueDate', comparator: dateComparator, minWidth: 100 },
    { headerName: 'On order', field: 'OnOrderDisplay', minWidth: 100, suppressSorting: true },
    { headerName: 'Committed', field: 'CommittedDisplay', minWidth: 100, suppressSorting: true },
    { headerName: 'Supplied', field: 'SuppliedDisplay', minWidth: 100, suppressSorting: true },
    { headerName: 'Supplier name', field: 'SupplierName', minWidth: 200, suppressSorting: true },
    { headerName: 'Warehouse name', field: 'WarehouseName', minWidth: 200, suppressSorting: true },
  ],
  Data: [],
  selectedFilters: {
    EntityView: 'MPRO',
    Warehouse: '',
  },
  filterRow: {
    formName: 'IEPurchaseOrdersFilters',
    hidePreFilters: false,
    parameters: [
      {
        id: 0,
        type: 'EX_LOOKUP_FIELD',
        props: {
          label: 'Entity view',
          name: 'EntityView',
          lookupName: 'EntityView',
          size: 'small',
          required: true
        }
      },
      {
        id: 1,
        type: 'EX_LOOKUP_FIELD',
        props: {
          label: 'Warehouse',
          name: 'Warehouse',
          lookupName: 'WarehouseEntity',
          size: 'small',
          required: false
        }
      }
    ]
  },
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.reset:
      return initialState;
    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }
    case types.setEntityView:
      const entityView = action.data.defaultView;
      const warehouse = action.data.defaultWarehouse;
      return {
        ...state,
        data: {
          ...state.data,
          selectedFilters: {
            ...state.data.selectedFilters,
            EntityView: entityView,
            Warehouse: warehouse
          }
        }
      };

    default:
      return state
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.inventoryEnquiry.reordering.purchaseOrders,
  {
    data: data => data.Data,
    selected: data => data.selected,
  }
)

const syncSelector = {
  isLoading: state => state.inventoryEnquiry.reordering.purchaseOrders.fetch_loading,
  gridOptions: state => state.inventoryEnquiry.reordering.purchaseOrders.data.gridOptions,
  columns: state => state.inventoryEnquiry.reordering.purchaseOrders.data.Columns,
  filterRow: state => state.inventoryEnquiry.reordering.purchaseOrders.data.filterRow,
  selectedFilters: state => state.inventoryEnquiry.reordering.purchaseOrders.data.selectedFilters,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)